// extracted by mini-css-extract-plugin
module.exports = {"form":"login_form__sOZBR","fieldset":"login_fieldset__1LEPM","field":"login_field__24GX7","forgot-password-link":"login_forgot-password-link__HtiJJ"};